import List from 'src/storage/treatmentsList';

class TreatmentsTreatmentsModel extends List {
  id = 'TreatmentsTreatmentsModel';
  defaultState = () => ({
    images: [],
    medicines: [this.defaultMedicines()],
    current: 'recent',
    sortBy: {
      sortKey: 'date',
      desc: true
    }
  });
  defaultMedicines = () => ({
    name: '',
    doze: null,
    days: null,
    period: null,
    times: []
  });
  refreshOnInit = false;
  refreshOnSubscribe = true;
  sortBy = null;
  apiConfig = {
    refresh: {
      url: 'treatment/refresh',
      validation: {
        partnerId: 'userId',
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    list: {
      url: 'treatment/list',
      validation: {
        partnerId: 'userId',
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    search: {
      url: 'treatment/search',
      validation: {
        partnerId: 'userId',
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    updatePrivacySettings: {
      url: '/treatment/update/privacySettings',
      validation: {
        id: 'baseId'
      },
      cancellable: true
    }
  };

  _events = {
    'foxsocket:message:treatment': 'onMessage',
    profile: 'handleProfile'
  };
  handleProfile = (profile) => {
    this.setState({ user: profile });
  };

  filterItem = (data) => {
    if (data.to !== this.userId && data.from !== this.userId) return false;
    return this.onFilterOtherItem(data);
  };

  listParams(loadMore) {
    let req = {
      partnerId: 0,
      skip: 0,
      limit: this.listLimit,
      sortBy: this.state.sortBy
    };

    let query = this.listInput('search');
    if (query.length > 0) {
      req.query = query;
    }
    if (loadMore) {
      let skip = this.items().length;
      if (skip < this.listLimit) return null;
      req.skip = skip;
    }
    return req;
  }

  updatePrivacySettings = ({ id, privacySettings, cb }) => {
    let req = {
      id,
      privacySettings
    };
    this.api('updatePrivacySettings', req, (err, data, success) => {
      cb && cb(err, data, success);
      if (!err) this.onFilterOtherItem(data);
    });
  };
}

const model = new TreatmentsTreatmentsModel();
export default model;
